import { useMutation } from 'react-query';
import axios from 'axios';
import { API_CLIENT_HEADERS } from 'api/OpenApiConfiguration';
import useLazySnackbar from 'components/banners/useLazySnackbar';

export const useCheckEmailMutation = () =>
  useMutation((email: string) =>
    axios.get('/domestic/v1/users/check_email', {
      params: {
        email,
      },
      headers: API_CLIENT_HEADERS,
    })
  );

export const useResetPasswordMutation = () => {
  const { enqueueSnackbar } = useLazySnackbar();

  return useMutation(
    (body: { email: string }) =>
      axios.post('/domestic/v1/me/password/forgot', body, {
        headers: API_CLIENT_HEADERS,
      }),
    {
      onError() {
        enqueueSnackbar('Email not found.', {
          variant: 'error',
          autoHideDuration: 5000,
        });
      },
    }
  );
};

type SetPasswordBody = {
  password: string;
  password_confirmation: string;
  reset_password_token: string;
};

export const useSetNewPasswordWithTokenMutation = () => {
  const { enqueueSnackbar } = useLazySnackbar();

  return useMutation(
    (body: SetPasswordBody) =>
      axios.patch('/domestic/v1/me/password/reset', body, {
        headers: API_CLIENT_HEADERS,
      }),
    {
      onError() {
        enqueueSnackbar('Unable to update password.', {
          variant: 'error',
          autoHideDuration: 5000,
        });
      },
    }
  );
};
